// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portal-status-pill[data-v-963ee2f2] {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  min-height: 26px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: var(--status-background);\n  color: var(--status-color);\n  font-size: 12px;\n  font-weight: 650;\n  line-height: 1.25;\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
